'use client'; // https://wagmi.sh/react/guides/ssr

import { ReactNode } from 'react';

import { State, WagmiProvider } from 'wagmi';

import { wagmiAdapter } from '@shared/common/providers/Web3Provider/wagmi';
import { WALLET_CONNECT_PROJECT_ID } from '@shared/constants';

import { createAppKit } from '@reown/appkit/react';
import { AppKitNetwork } from '@reown/appkit-common';

import { metadata } from './configuration';

if (!WALLET_CONNECT_PROJECT_ID) {
  throw new Error('Wallet Connect Project ID is not defined');
}

createAppKit({
  adapters: [wagmiAdapter],
  networks: wagmiAdapter.networks as [AppKitNetwork, ...AppKitNetwork[]],
  metadata,
  projectId: WALLET_CONNECT_PROJECT_ID,
  features: {
    analytics: true,
    onramp: true,
    socials: false,
    email: false,
  },
});

// NOTE: QueryClientProvider must be used inside if WagmiProvider just as in the documentation
const Web3Provider = ({
  children,
  initialState,
}: {
  children?: ReactNode;
  initialState?: State;
}) => {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig} initialState={initialState}>
      {children}
    </WagmiProvider>
  );
};

export default Web3Provider;
